import { m } from '../mithril';

export const rose = m(
	'svg',
	{
		width: '400px',
		height: '400px',
		viewBox: '0 0 24 24',
	},
	[
		m('path', {
			d: 'm4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z',
			fill: 'currentColor',
			'stroke-width': '1%',
			stroke: 'white',
		}),
	]
);
